// The design families of the template catalog, each in its own module: its single-post
// designs, carousels, catalog entries (with the palette and type pairing they are drawn
// in) and copy in pt_BR, en_US and es_ES. artSamples.js merges them into the catalog.
import bubbles from './bubbles';

const ART_DESIGN_FAMILIES = [bubbles];

export default ART_DESIGN_FAMILIES;
